import React from 'react';
import { useField } from 'formik';
import { NSInput } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import { InputType } from 'reactstrap/es/Input';
import { useAttributeSuggested } from 'components/DealForm/hooks/useSuggestedAttribute';
import { DefaultAttributes } from '../../types';

interface DefaultAttributeInputProps {
  name: string;
  label: string;
  placeholder?: string;
  type?: InputType;
  attribute: DefaultAttributes;
  showSuggestedOnly: boolean;
  className?: string;
  prependInputAddon?: string | JSX.Element | null;
  rows?: number;
  additionalRenderCondition?: boolean;
  onBlur?: (value: string) => void;
}

const DefaultAttributeInput: React.FC<DefaultAttributeInputProps> = ({
    name,
    label,
    placeholder,
    type = 'text',
    attribute,
    showSuggestedOnly,
    className = '',
    prependInputAddon,
    rows,
    additionalRenderCondition = true,
    onBlur,
}) => {
    const [field, meta] = useField(name);

    const { isRequired, shouldRender } = useAttributeSuggested({
        attribute,
        showSuggestedOnly,
        additionalRenderCondition,
    });

    const handleBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
        field.onBlur(e);
        if (onBlur) {
            onBlur(e.target.value);
        }
    };

    return (
        <RenderIf isTrue={shouldRender}>
            <div className={className}>
                <NSInput
                    label={label}
                    type={type}
                    placeholder={placeholder}
                    prependInputAddon={prependInputAddon}
                    errorMsg={meta.touched && meta.error ? meta.error : null}
                    showErrorMsg={!!(meta.touched && meta.error)}
                    required={isRequired}
                    rows={rows}
                    {...field}
                    onBlur={handleBlur}
                />
            </div>
        </RenderIf>
    );
};

export default DefaultAttributeInput;
